// ShapeElement

var ShapeElement = (function() {

  var config = {
    border: {
      width: 1,
      lineDash: [3, 2],
      strokeStyle: "rgb(0, 0, 0)",
    },
    bounds: {
      strokeStyle: "rgb(100, 100, 100)",
    },
    tail: {
      strokeStyle: "rgb(0, 0, 0)",
    },
    segments: 20,
    density: 1,
  };

  function ShapeElement(options) {

    options = options || {};

    if (!options.layer ||
      !options.layer.canvas ||
      !options.layer.canvas.context
    ) return;

    var self = this;

    this.context = options.layer.canvas.context;
    this.canvas = this.context.canvas;

    var tail = options.tail || {};
    this.debug = options.debug || {};
    options = options.shape || {};

    this.color = options.color;
    var defaultOutline = ShapeElement.bubbles().oval;
    this.outline = ShapeElement.bubbles()[options.outline] || defaultOutline;

    var lineWidth = options.lineWidth;
    this.lineWidth = lineWidth || lineWidth === 0 ? lineWidth : 1.0;
    this.strokeStyle = options.strokeStyle || "rgb(100, 100, 100)";
    this.border = options.border ? {
      color: options.border.color,
      size: options.border.size,
      dash: [
        options.border.dash["0"],
        options.border.dash["1"],
      ],
    } : {
      color: "#000",
      size: 1,
      dash: [0, 0],
    };

    // Property to handle the scale
    this._scale = options.scale || 2;

    var control = tail.control
      ? new Vector2(tail.control.x, tail.control.y)
      : new Vector2();
    var position = tail.position
      ? new Vector2(tail.position.x, tail.position.y)
      : new Vector2(500, 500);
    var intersect = tail.intersect
      ? new Vector2(tail.intersect.x, tail.intersect.y)
      : new Vector2(500, 500);
    this.tail = {
      type: tail.type || "curved",
      position: position, //.scale(this.scale),
      width: tail.width || 2,
      control: control,
      points: {
        start: new Vector2(),
        end: new Vector2(),
        intersect: intersect,
        tail: new Vector2(),
        control: new Vector2(),
      },
      custom: {
        tail: false, //!!tail.position,
        intersect: !!tail.intersect,
        control: false, //!!tail.control,
      },
      handle: tail.handle || {
        radius: 20
      },
    };

    this.bounds = this.getBounds();

    if (options.bounds) {
      // console.log("bounds", options.bounds, this.bounds);
      this.bounds.move(options.bounds.left, options.bounds.top);
      // this.bounds.resize(options.bounds.width, options.bounds.height);
      this.resizeShape(new Vector2(options.bounds.width, options.bounds.height));
    } else {
      this.bounds.move(50 * this._scale, 50 * this._scale); // HACK
    }

    this.points = this.getAllPoints(true);
    this.panel = this.getPanelBounds();

  }

  // Property to handle the scale
  Object.defineProperty(ShapeElement.prototype, "scale", {
    set: function(scale) {
      this._scale = scale;
    },
    get: function() {
      return this._scale * config.density;
    },
  });

  // Draw the shape to the canvas
  ShapeElement.prototype.updateCanvas = function(isEditing, isDragging) {

    this.editing = isEditing;
    this.bounds = this.getBounds();
    this.points = this.getAllPoints(!isDragging);
    this.panel = this.getPanelBounds();

    this.drawShape();

    if (this.tail.type !== "none") {
      this.drawTail();
    }

    if (!isEditing) {
      return;
    }

    if (this.debug.intersects) {
      this.drawAllPoints();
    }
    if (this.debug.bounds) {
      this.drawBounds();
    }
    this.drawHandles();

  };

  // Draw the shape to the canvas
  ShapeElement.prototype.drawShape = function() {

    var self = this;
    var bounds = this.bounds.getScaledBounds();

    this.context.save();

    this.context.scale(this.scale, this.scale);

    this.context.beginPath();

    this.context.moveTo(
      this.outline.start.x + bounds.left,
      this.outline.start.y + bounds.top
    );

    this.outline.paths.forEach(function(path, index) {
      self.context.bezierCurveTo(
        path.start.x + bounds.left,
        path.start.y + bounds.top,
        path.control.x + bounds.left,
        path.control.y + bounds.top,
        path.end.x + bounds.left,
        path.end.y + bounds.top
      );
    });

    this.context.closePath();

    this.context.fillStyle = this.color || "rgba(255, 255, 255, 1)";
    this.context.fill();

    var size = this.border.size;
    var lineWidth = size || size === 0 ? size : config.border.width;
    if (lineWidth > 0 && lineWidth / config.density > 0) {
      this.context.lineWidth = lineWidth / config.density;
      this.context.setLineDash(this.border.dash || config.border.lineDash);
      this.context.strokeStyle = this.border.color || config.border.strokeStyle;
      this.context.stroke();
    }

    this.context.restore();

  };

  // Draw the points along the shape outline on the canvas
  ShapeElement.prototype.drawAllPoints = function() {

    var self = this;

    this.points.forEach(function(point) {
      var highlight = point === self.pointClosestToMouse;
      var bounds = self.bounds.getScaledBounds();
      var position = new Vector2(point.x + bounds.left, point.y + bounds.top);
      self.drawPoint(position, {
        radius: (highlight ? 4 : 2) / config.density,
        fillStyle: highlight ? "#ff0000" : "#ff0000",
        strokeStyle: "rgba(0, 0, 0, 0)",
        lineWidth: 2,
      });
    });

  };

  // Draw the points along the shape outline on the canvas
  ShapeElement.prototype.drawPoint = function(point, options) {

    options = options || {};

    var radius = options.radius || 20 / this.scale;

    this.context.save();

    this.context.scale(this.scale, this.scale);

    this.context.beginPath();
    this.context.arc(point.x, point.y, radius, 0, Math.PI * 2);
    this.context.closePath();

    this.context.fillStyle = options.fillStyle || "rgba(0, 0, 0, 0.5)";
    this.context.fill();

    if (options.lineWidth !== 0) {
      var strokeStyle = options.strokeStyle || "rgba(255, 255, 255, 0.8)";
      this.context.strokeStyle = strokeStyle;
      this.context.lineWidth = options.lineWidth || 2.0 / this.scale;
      this.context.stroke();
    }

    this.context.restore();

  };

  // Draw the tail shape on the canvas
  ShapeElement.prototype.drawTail = function() {

    var scaledBounds = this.bounds.getScaledBounds();
    var scaledCenter = new Vector2(
      scaledBounds.left + (scaledBounds.width / 2),
      scaledBounds.top + (scaledBounds.height / 2)
    );

    this.context.save();

    this.context.scale(this.scale, this.scale);

    this.drawTailShape();

    if (this.tail.type !== "thought") {

      var centerDistance = new Vector2(
        (this.tail.points.intersect.x - scaledCenter.x) / scaledBounds.width,
        (this.tail.points.intersect.y - scaledCenter.y) / scaledBounds.height
      );

      this.context.moveTo(
        this.tail.points.end.x,
        this.tail.points.end.y
      );

      this.context.quadraticCurveTo(
        this.tail.points.end.x - (60 * centerDistance.x),
        this.tail.points.end.y - (60 * centerDistance.y),
        this.tail.points.start.x,
        this.tail.points.start.y
      );

      this.context.closePath();
      this.context.fillStyle = this.color || "rgba(255, 255, 255, 1)";
      this.context.fill();

      this.drawTailShape();

      var size = this.border.size;
      var lineWidth = size || size === 0 ? size : config.border.width;

      if (lineWidth > 0 && lineWidth / config.density > 0) {
        this.context.lineCap = "round";
        this.context.lineWidth = lineWidth / config.density;
        this.context.setLineDash(this.border.dash || config.border.lineDash);
        this.context.strokeStyle = this.border.color || config.tail.strokeStyle;
        this.context.stroke();
      }

    }

    this.context.restore();

    if (!this.editing || !this.debug.tail) {
      return;
    }

    this.drawTailAnchor();

  };

  // Draw the tail shape on the canvas
  ShapeElement.prototype.drawTailShape = function() {

    var tail = this.tail;
    var scaledBounds = this.bounds.getScaledBounds();
    var closestPoint = this.pointClosestToMouse;
    var scaledMouseX = tail.position.x / this.scale;
    var scaledMouseY = tail.position.y / this.scale;
    var start = this.points.indexOf(closestPoint) - tail.width;
    var end = this.points.indexOf(closestPoint) + tail.width;
    var length = this.points.length;
    var midpoint = new Vector2();
    var control = new Vector2();

    // Ensure within range
    start = start >= 0 ? start : length + start;
    end = end <= length - 1 ? end : -(length - end);

    // Set intersect point
    if (!tail.custom.intersect) {
      tail.points.intersect = new Vector2(
        closestPoint.x + scaledBounds.left,
        closestPoint.y + scaledBounds.top
      );
    }

    // Set tail point
    if (!tail.custom.tail) {
      tail.points.tail = new Vector2(scaledMouseX, scaledMouseY);
    }

    // Set start and end point
    tail.points.start = new Vector2(
      this.points[start].x + scaledBounds.left,
      this.points[start].y + scaledBounds.top
    );
    tail.points.end = new Vector2(
      this.points[end].x + scaledBounds.left,
      this.points[end].y + scaledBounds.top
    );

    // Set start control point
    if (!tail.custom.control) {
      midpoint = new Vector2(
        tail.points.tail.x - tail.points.intersect.x,
        tail.points.tail.y - tail.points.intersect.y
      );
      control = new Vector2(
        tail.points.intersect.x + (midpoint.x / 2) + tail.control.x,
        tail.points.intersect.y + (midpoint.y / 2) + tail.control.y
      );
      tail.points.control = control;
    }

    // Draw the dots if a thought bubble
    if (tail.type === "thought") {

      var size = tail.width;
      var distance = size * 5;
      var angle = Math.atan2(
        tail.points.tail.y - tail.points.intersect.y,
        tail.points.tail.x - tail.points.intersect.x
      );

      var min = 10;
      distance = distance < min ? min : distance; // HACK: Sets min spacing

      var sin = Math.sin(angle) * distance;
      var cos = Math.cos(angle) * distance;

      var xs = tail.points.tail.x - tail.points.intersect.x;
      var ys = tail.points.tail.y - tail.points.intersect.y;
      var length = Math.floor(Math.sqrt((xs * xs) + (ys * ys)));
      var count = Math.floor(length / distance);

      for (var i = 0; i <= count; i++) {
        var position = new Vector2(
          Math.floor(tail.points.intersect.x + (cos * i)),
          Math.floor(tail.points.intersect.y + (sin * i))
        );
        var x = size + ((size / count) * (count - i - 1));
        var radius = new Vector2(x, x / 1.5);
        this.drawEllipse(position, radius);
      }

      return;

    }

    this.context.beginPath();

    this.context.moveTo(
      tail.points.start.x,
      tail.points.start.y
    );

    // Draw the line/curve from the edge intersect to the tail point
    midpoint = new Vector2(
      tail.points.tail.x - tail.points.start.x,
      tail.points.tail.y - tail.points.start.y
    );
    control = new Vector2(
      tail.points.start.x + (midpoint.x / 2) + tail.control.x,
      tail.points.start.y + (midpoint.y / 2) + tail.control.y
    );
    this.context.quadraticCurveTo(
      tail.points.start.x + (control.x - tail.points.start.x),
      tail.points.start.y + (control.y - tail.points.start.y),
      tail.points.tail.x,
      tail.points.tail.y
    );

    // Draw the line/curve from the tail point to the edge intersect
    midpoint = new Vector2(
      tail.points.tail.x - tail.points.end.x,
      tail.points.tail.y - tail.points.end.y
    )
    control = new Vector2(
      tail.points.end.x + (midpoint.x / 2) + tail.control.x,
      tail.points.end.y + (midpoint.y / 2) + tail.control.y
    );
    this.context.quadraticCurveTo(
      tail.points.tail.x + (control.x - tail.points.tail.x),
      tail.points.tail.y + (control.y - tail.points.tail.y),
      tail.points.end.x,
      tail.points.end.y
    );

  };

  // Draw the tail anchor on the canvas
  ShapeElement.prototype.drawTailAnchor = function() {

    var scaledBounds = this.bounds.getScaledBounds();
    var closestPoint = this.pointClosestToMouse;
    var scaledMouseX = this.tail.position.x / this.scale;
    var scaledMouseY = this.tail.position.y / this.scale;
    var start = new Vector2(
      closestPoint.x + scaledBounds.left,
      closestPoint.y + scaledBounds.top
    );

    this.context.save();

    this.context.scale(this.scale, this.scale);

    this.context.beginPath();

    this.context.moveTo(start.x, start.y);

    // Draw the line/curve from the edge intersect to the tail point
    this.context.quadraticCurveTo(
      start.x + (this.tail.points.control.x - this.tail.points.intersect.x),
      start.y + (this.tail.points.control.y - this.tail.points.intersect.y),
      scaledMouseX,
      scaledMouseY
    );

    this.context.setLineDash([2, 2]);
    this.context.lineWidth = (config.border.width / 3) / this.scale;
    this.context.strokeStyle = config.tail.strokeStyle;
    this.context.stroke();

    this.context.restore();

  };

  // Draws an ellipse shape
  ShapeElement.prototype.drawEllipse = function(center, radius) {

    this.context.save();
    this.context.beginPath();
    this.context.translate(center.x - radius.x, center.y - radius.y);
    this.context.scale(radius.x + this.scale, radius.y + this.scale);
    this.context.arc(1, 1, 1, 0, 2 * Math.PI, false);
    this.context.restore();

    this.context.save();
    this.context.fillStyle = this.color || "rgba(255, 255, 255, 1)";
    this.context.fill();
    this.context.restore();

    this.context.save();
    var size = this.border.size;
    var lineWidth = size || size === 0 ? size : config.border.width;
    if (lineWidth > 0 && lineWidth / config.density > 0) {
      this.context.lineWidth = lineWidth / config.density;
      this.context.setLineDash(this.border.dash || config.border.lineDash);
      this.context.strokeStyle = this.border.color || config.border.strokeStyle;
      this.context.stroke();
    }
    this.context.restore();

  };

  // Draw the handles of the shape on the canvas
  ShapeElement.prototype.drawHandles = function() {

    var bounds = this.bounds.getScaledBounds();
    var tail = this.tail;

    this.drawPoint(new Vector2(bounds.left, bounds.top));
    this.drawPoint(new Vector2(bounds.right, bounds.top));
    this.drawPoint(new Vector2(bounds.left, bounds.bottom));
    this.drawPoint(new Vector2(bounds.right, bounds.bottom));

    if (tail.type === "none") {
      return;
    }

    var points = tail.points;
    var options = {
      lineWidth: 2 / this.scale
    };

    options.radius = tail.handle.radius / this.scale;
    options.fillStyle = "rgba(100, 0, 0, 1)";
    options.strokeStyle = "rgba(50, 0, 0, 1)";
    this.drawPoint(tail.position.scale(1 / this.scale), options);

    options.radius = 10 / this.scale;
    options.fillStyle = "red";
    options.strokeStyle = "darkred";
    this.drawPoint(tail.points.intersect, options);

    if (tail.type === "straight" || tail.type === "thought") {
      return;
    }

    options.radius = 10 / this.scale;
    options.fillStyle = "blue";
    options.strokeStyle = "darkblue";
    this.drawPoint(new Vector2(points.control.x, points.control.y), options);

  };

  // Draw the bounding box of the shape on the canvas
  ShapeElement.prototype.drawBounds = function() {

    this.context.save();

    this.context.lineWidth = config.border.width / this.scale;
    this.context.strokeStyle = config.bounds.strokeStyle;

    this.context.beginPath();
    this.context.rect(
      this.bounds.left,
      this.bounds.top,
      this.bounds.width,
      this.bounds.height
    );
    this.context.stroke();

    this.context.beginPath();
    this.context.rect(
      this.panel.left,
      this.panel.top,
      this.panel.width,
      this.panel.height
    );
    this.context.stroke();

    this.context.restore();

  };

  // Resize the same and outline paths
  ShapeElement.prototype.resizeShape = function(size) {

    var resizeRatio = new Vector2(
      size.x / this.bounds.width,
      size.y / this.bounds.height
    );

    this.bounds.resize(size.x, size.y);

    this.outline.start.x *= resizeRatio.x;
    this.outline.start.y *= resizeRatio.y;
    this.outline.paths.forEach(function(path, index) {
      for (var key in path) {
        path[key].x *= resizeRatio.x;
        path[key].y *= resizeRatio.y;
      }
    });

  };

  // Get the coordinates for the bounding box of the shape
  ShapeElement.prototype.getBounds = function() {

    var offset = this.bounds ?
      new Vector2(this.bounds.left / this.scale, this.bounds.top / this.scale) :
      new Vector2();

    var max = new Vector2(0, 0);
    var min = new Vector2(0, 0);

    function checkPoint(point) {
      if (point.x > max.x) max.x = point.x;
      if (point.x < min.x) min.x = point.x;
      if (point.y > max.y) max.y = point.y;
      if (point.y < min.y) min.y = point.y;
    }

    checkPoint(this.outline.start);

    // Loop over all points to find the outer most
    this.outline.paths.forEach(function(path) {
      for (var key in path) {
        checkPoint(path[key]);
      }
    });

    return new Bounds(
      min.y + offset.y,
      min.x + offset.x,
      max.x - min.x,
      max.y - min.y,
      this.scale
    );

  };

  // Get the coordinates for the text panel
  ShapeElement.prototype.getPanelBounds = function() {

    var scale = this.scale
    var panel = this.outline.panel;
    var density = scale / config.density;
    var offset = new Vector2(
      this.bounds.width * panel.padding.x,
      this.bounds.height * panel.padding.y
    );

    return new Bounds(
      this.bounds.top / scale, // + offset.y
      this.bounds.left / scale, // + offset.x
      this.bounds.width / scale, // - (offset.x * 2)
      this.bounds.height / scale, // - (offset.y * 2)
      scale
    );

  };

  // Draw the points along the shape outline on the canvas
  ShapeElement.prototype.getPointClosestToMouse = function(points, position) {

    var scaledBounds = this.bounds.getScaledBounds();
    var x = (position.x / this.scale) - scaledBounds.left;
    var y = (position.y / this.scale) - scaledBounds.top;
    var targetPosition = new Vector2(x, y);
    var closestPoint = points[0];
    var closestDistance = closestPoint.distanceTo(targetPosition);
    var currentDistance = closestDistance;

    points.forEach(function(point) {
      currentDistance = point.distanceTo(targetPosition);
      if (currentDistance < closestDistance) {
        closestPoint = point;
        closestDistance = currentDistance;
      }
    });

    return closestPoint;

  };

  // Get the intersecting points along the outline of the shape
  ShapeElement.prototype.getAllPoints = function(initial) {

    var self = this;
    var start = this.outline.start;
    var points = [this.outline.start];
    var tail = this.tail;

    this.outline.paths.forEach(function(path) {
      var length = self.getSegmentLength(start, path, points);
      var segments = 0.2 / (length / (config.segments / self.scale));
      var options = {
        start: start,
        path: path,
        segments: segments
      };
      var parts = self.getSegmentPoints(options);
      parts.forEach(function(point) {
        points.push(point);
      });
      start = new Vector2(path.end.x, path.end.y);
    });

    if (this.tail.custom.intersect) {
      var position = tail.points.intersect.scale(this.scale);
      this.pointClosestToMouse = this.getPointClosestToMouse(points, position);
      // if (!initial) {
      var point = this.pointClosestToMouse;
      var bounds = this.bounds.getScaledBounds();
      tail.points.intersect = (new Vector2(
        point.x + bounds.left,
        point.y + bounds.top
      ));
      // }
    } else {
      var position = tail.position;
      this.pointClosestToMouse = this.getPointClosestToMouse(points, position);
    }

    return points;

  };

  // Get the normalizd points that are rounded and unique
  ShapeElement.prototype.getAllPointsNormalized = function() {

    var self = this;

    this.points = this.points.filter(function(point, index, self) {
      var found = self.findIndex(function(current) {
        return Math.round(current.x) === Math.round(point.x) &&
          Math.round(current.y) === Math.round(point.y);
      });
      return found === index;
    });

  };

  // Get the length of a segment along the outline of the shape
  ShapeElement.prototype.getSegmentLength = function(start, path, points) {

    var options = {
      start: start,
      path: path,
      segments: null
    };
    var points = this.getSegmentPoints(options);
    var current = points[0];
    var length = 0;
    var self = this;

    points.forEach(function(point) {
      length += point.distanceTo(current);
      current = point;
    });

    return length;

  };

  // Get the intersecting points along the segment
  ShapeElement.prototype.getSegmentPoints = function(options) {

    var points = [];
    var point = null;
    var index = 0;
    var length = 1;
    var segments = options.segments || 0.1;

    for (; index <= length; index += segments) {
      point = this.getSegmentPoint(options.start, options.path, index);
      points.push(point);
    }

    return points;

  };

  // Get the specified intersecting point along the segment
  ShapeElement.prototype.getSegmentPoint = function(start, path, index) {

    // quadraticCurveTo
    // var i1 = 2 * (1 - i);
    // var x = start.x + i * (i1 * (control.x-start.x) + i * (end.x-start.x));
    // var y = start.y + i * (i1 * (control.y-start.y) + i * (end.y-start.y));

    // bezierCurveTo
    var x = this.getCubicBezierPoint({
      index: index,
      start: start.x,
      left: path.start.x,
      right: path.control.x,
      end: path.end.x,
    });

    var y = this.getCubicBezierPoint({
      index: index,
      start: start.y,
      left: path.start.y,
      right: path.control.y,
      end: path.end.y,
    });

    return new Vector2(x, y);

  };

  // Get the intersecting points along the segment
  ShapeElement.prototype.getCubicBezierPoint = function(options) {

    var index = options.index;
    var start = options.start;
    var left = options.left;
    var right = options.right;
    var end = options.end;

    var i = 1 - index;

    return Math.round((i * i * i) * start +
      3 * (i * i) * index * left +
      3 * i * (index * index) * right +
      (index * index * index) * end
    );

  };

  // The vectorized bubble / balloon shapes
  ShapeElement.bubbles = function() {
    return {
      rectangle: {
        id: "rectangle",
        start: new Vector2(0.0, 0.0),
        panel: {
          padding: new Vector2(0, 0)
        },
        paths: [{
            start: new Vector2(325, 0),
            control: new Vector2(325, 0),
            end: new Vector2(325, 0),
          },
          {
            start: new Vector2(325, 250),
            control: new Vector2(325, 250),
            end: new Vector2(325, 250),
          },
          {
            start: new Vector2(0, 250),
            control: new Vector2(0, 250),
            end: new Vector2(0, 250),
          },
          {
            start: new Vector2(0, 0),
            control: new Vector2(0, 0),
            end: new Vector2(0, 0),
          },
        ],
      },
      oval: {
        id: "oval",
        start: new Vector2(176.0, 46.0),
        panel: {
          padding: new Vector2(0.075, 0.15)
        },
        paths: [{
            start: new Vector2(176.0, 58.4),
            control: new Vector2(173.1, 73.2),
            end: new Vector2(157.3, 81.4),
          },
          {
            start: new Vector2(141.5, 89.5),
            control: new Vector2(112.7, 91.0),
            end: new Vector2(88.5, 91.0),
          },
          {
            start: new Vector2(64.3, 91.0),
            control: new Vector2(35.8, 89.7),
            end: new Vector2(19.9, 81.5),
          },
          {
            start: new Vector2(4.1, 73.4),
            control: new Vector2(1.0, 58.4),
            end: new Vector2(1.0, 46.0),
          },
          {
            start: new Vector2(1.0, 33.6),
            control: new Vector2(3.8, 18.9),
            end: new Vector2(19.7, 10.7),
          },
          {
            start: new Vector2(35.5, 2.6),
            control: new Vector2(64.3, 1.0),
            end: new Vector2(88.5, 1.0),
          },
          {
            start: new Vector2(112.7, 1.0),
            control: new Vector2(140.8, 2.8),
            end: new Vector2(156.6, 11.0),
          },
          {
            start: new Vector2(172.5, 19.1),
            control: new Vector2(176.0, 33.6),
            end: new Vector2(176.0, 46.0),
          },
        ],
      },
      thought: {
        id: "thought",
        start: new Vector2(275.5, 77.6),
        panel: {
          padding: new Vector2(0.1, 0.15)
        },
        paths: [{
            start: new Vector2(275.5, 70.3),
            control: new Vector2(271.1, 63.6),
            end: new Vector2(264.0, 58.8),
          },
          {
            start: new Vector2(266.3, 56.5),
            control: new Vector2(267.7, 53.7),
            end: new Vector2(267.7, 50.8),
          },
          {
            start: new Vector2(267.7, 45.5),
            control: new Vector2(263.4, 40.9),
            end: new Vector2(257.0, 38.5),
          },
          {
            start: new Vector2(257.0, 38.1),
            control: new Vector2(257.0, 37.7),
            end: new Vector2(257.0, 37.3),
          },
          {
            start: new Vector2(257.0, 22.5),
            control: new Vector2(239.2, 10.4),
            end: new Vector2(217.2, 10.4),
          },
          {
            start: new Vector2(211.5, 10.4),
            control: new Vector2(206.0, 11.3),
            end: new Vector2(201.1, 12.7),
          },
          {
            start: new Vector2(197.3, 8.9),
            control: new Vector2(190.8, 6.4),
            end: new Vector2(183.5, 6.4),
          },
          {
            start: new Vector2(178.7, 6.4),
            control: new Vector2(174.4, 7.5),
            end: new Vector2(170.8, 9.3),
          },
          {
            start: new Vector2(161.9, 3.9),
            control: new Vector2(149.1, 0.5),
            end: new Vector2(134.8, 0.5),
          },
          {
            start: new Vector2(121.1, 0.5),
            control: new Vector2(108.6, 3.7),
            end: new Vector2(99.8, 8.7),
          },
          {
            start: new Vector2(96.4, 7.3),
            control: new Vector2(92.5, 6.4),
            end: new Vector2(88.2, 6.4),
          },
          {
            start: new Vector2(81.1, 6.4),
            control: new Vector2(74.8, 8.8),
            end: new Vector2(71.0, 12.4),
          },
          {
            start: new Vector2(66.4, 11.1),
            control: new Vector2(61.4, 10.4),
            end: new Vector2(56.1, 10.4),
          },
          {
            start: new Vector2(34.6, 10.4),
            control: new Vector2(17.1, 21.9),
            end: new Vector2(16.3, 36.3),
          },
          {
            start: new Vector2(9.3, 38.6),
            control: new Vector2(4.5, 43.4),
            end: new Vector2(4.5, 49.0),
          },
          {
            start: new Vector2(4.5, 52.7),
            control: new Vector2(6.5, 56.0),
            end: new Vector2(9.9, 58.5),
          },
          {
            start: new Vector2(4.0, 63.2),
            control: new Vector2(0.5, 69.2),
            end: new Vector2(0.5, 75.8),
          },
          {
            start: new Vector2(0.5, 82.3),
            control: new Vector2(3.9, 88.2),
            end: new Vector2(9.6, 92.9),
          },
          {
            start: new Vector2(7.7, 95.0),
            control: new Vector2(6.5, 97.5),
            end: new Vector2(6.5, 100.2),
          },
          {
            start: new Vector2(6.5, 106.3),
            control: new Vector2(12.2, 111.4),
            end: new Vector2(20.2, 113.5),
          },
          {
            start: new Vector2(20.1, 113.8),
            control: new Vector2(20.1, 114.1),
            end: new Vector2(20.1, 114.4),
          },
          {
            start: new Vector2(20.1, 129.2),
            control: new Vector2(38.0, 141.2),
            end: new Vector2(60.0, 141.2),
          },
          {
            start: new Vector2(65.0, 141.2),
            control: new Vector2(69.8, 140.6),
            end: new Vector2(74.3, 139.4),
          },
          {
            start: new Vector2(78.0, 143.4),
            control: new Vector2(84.6, 146.1),
            end: new Vector2(92.2, 146.1),
          },
          {
            start: new Vector2(96.3, 146.1),
            control: new Vector2(100.2, 145.2),
            end: new Vector2(103.5, 143.8),
          },
          {
            start: new Vector2(112.1, 148.0),
            control: new Vector2(123.3, 150.5),
            end: new Vector2(135.6, 150.5),
          },
          {
            start: new Vector2(147.5, 150.5),
            control: new Vector2(158.4, 148.1),
            end: new Vector2(166.9, 144.2),
          },
          {
            start: new Vector2(170.0, 145.4),
            control: new Vector2(173.6, 146.1),
            end: new Vector2(177.4, 146.1),
          },
          {
            start: new Vector2(186.1, 146.1),
            control: new Vector2(193.6, 142.5),
            end: new Vector2(196.8, 137.4),
          },
          {
            start: new Vector2(202.8, 139.8),
            control: new Vector2(209.7, 141.2),
            end: new Vector2(217.2, 141.2),
          },
          {
            start: new Vector2(239.2, 141.2),
            control: new Vector2(257.0, 129.2),
            end: new Vector2(257.0, 114.4),
          },
          {
            start: new Vector2(257.0, 113.8),
            control: new Vector2(257.0, 113.2),
            end: new Vector2(256.9, 112.6),
          },
          {
            start: new Vector2(263.3, 110.1),
            control: new Vector2(267.7, 105.5),
            end: new Vector2(267.7, 100.2),
          },
          {
            start: new Vector2(267.7, 98.3),
            control: new Vector2(267.1, 96.5),
            end: new Vector2(266.1, 94.9),
          },
          {
            start: new Vector2(272.0, 90.2),
            control: new Vector2(275.5, 84.2),
            end: new Vector2(275.5, 77.6),
          },
        ]
      },
    };
  };

  return ShapeElement;

})();
